var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("RouterLink", { attrs: { to: _vm.linkParams } }, [
    _c(
      "div",
      {
        staticClass:
          "box-content flex items-center h-8 border border-primary-500 rounded-full text-gray-800 bg-white tag-margin m-1 cursor-pointer",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "h-8 w-8 avatar bg-primary-500 rounded-full flex items-center justify-center text-lg text-white",
          },
          [_vm._v(_vm._s(_vm.applicantName[0]))]
        ),
        _c(
          "div",
          { staticClass: "flex text-sm cursor-pointer px-2 truncate" },
          [
            _c("span", { staticClass: "truncate" }, [
              _vm._v(_vm._s(_vm.applicantName)),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }